import { Component, input } from '@angular/core';
import {
    SocialBillingStatusWidgetComponent,
} from '../../billing/social-billing-status-widget/social-billing-status-widget.component';
import {
    SocialBillingUnbilledWorksWidgetComponent,
} from '../../billing/social-billing-unbilled-works-widget/social-billing-unbilled-works-widget.component';

@Component({
    selector: 'app-folder-billling-status-widget',
    templateUrl: './folder-billing-status-widget.component.html',
    styleUrl: './folder-billing-status-widget.component.scss',
    imports: [
        SocialBillingStatusWidgetComponent,
        SocialBillingUnbilledWorksWidgetComponent,
    ],
})
export class FolderBillingStatusWidgetComponent {

    public folderId = input.required<number, string | number>({
        transform: (it) => Number(it),
    });

}
